import { Node_Type } from "./../../ricos-types/index.js";
import { TiptapContentResolver } from "./../../toolbars-v3/ContentResolver.js";
const getLinkPreviewLinkData = TiptapContentResolver.create((content) => {
  if (Array.isArray(content)) {
    const node = content.find((node2) => {
      return node2.type.name === Node_Type.LINK_PREVIEW;
    });
    return node?.attrs.link;
  }
  return false;
});
export {
  getLinkPreviewLinkData
};
//# sourceMappingURL=get-link-prieview-link-data.js.map
